import { CardContainer, createForm } from '@application-production-system/react';
import { useNavigate, useParams } from 'react-router-dom';
import { AdminService } from '../../api/doc';
import { useAppSelector, useAppDispatch } from '../../hooks';
import { selectPlan, updatePlan } from '../../store/planSlice';
import { selectProductOptions } from '../../store/productSlice';
import { handleError } from '../../assets/constants';
import { CancelSubmitRow } from '../../components';
import { IdPageParams, ROUTES } from '../../routes';
import { Page } from '../../components/Page/Page';
import { useState } from 'react';

interface EditPlanForm {
    name: string;
    code: string;
    productCode: string;
    emailEnabled: boolean;
    cloudStorageEnabled: boolean;
    active: boolean;
}

const Form = createForm<EditPlanForm>();

function EditPlanPage() {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const { id } = useParams<IdPageParams>();
    const plan = useAppSelector((state) => selectPlan(state, id));

    const productOptions = useAppSelector(selectProductOptions);

    const [formData, setFormData] = useState<EditPlanForm>(plan as EditPlanForm);

    const onSubmit = () => {
        AdminService.updatePlan(plan.id!, formData)
            .then(response => {
                console.log(response);
                dispatch(updatePlan({
                    planCode: plan.code,
                    newDetails: response.plan
                }));
                navigate(ROUTES.planDetails.build({id: response.plan!.code}));
            })
            .catch(handleError);
    }

    return (
        <Page title={{page: "Plan Details", subPage: "Edit Plan Details", icon: ['far', 'clock']}}>
            <div style={{maxWidth: "600px"}}>
                <CardContainer title="Edit Plan">
                    <Form.Form onSubmit={onSubmit} data={formData} setData={setFormData}>
                        <Form.Entry  required for="name"        label="Name" />
                        <Form.Entry  required for="code"        label="Code" />
                        <Form.Select required for="productCode" label="Product Code" options={productOptions} />
                        <Form.Checkbox for="emailEnabled" label="Email Enabled" />
                        <Form.Checkbox for="cloudStorageEnabled" label="Cloud Storage Enabled" />
                        <Form.Checkbox        for="active"      label="Active" />
                        <CancelSubmitRow title="Save Changes" />
                    </Form.Form>
                </CardContainer>
            </div>
        </Page>
    );
}

export default EditPlanPage;
